import React, { Component, Fragment } from 'react';
import { withTranslation, Trans } from 'react-i18next';
import axios from 'axios';
import {
  withRouter,
  withAuthentication,
  AuthenticationContext,
  Tabs,
  Modal,
  Button,
  Notice,
  Form,
  ButtonSecondary,
  CallToActionCard,
  CheckboxElement,
  IconCard,
  RegularCard,
  ButtonCta,
  StackedCard,
  GelContentRow,
  Table,
  GelContentColumn,
  DocumentDownload,
  NotFound, GelContentContainer
} from 'cw-styleguide-react';
import i18n from "../i18n";
import config from '../config';
import { route } from "../routes";
import CardBackground from '../images/card.png';
import CardJobInformation from '../images/job-information.png';
import CardSubjectsJobs from '../images/subjects-jobs.png';
import CardCareerMatchQuiz from '../images/career-match-quiz.png';

class Animal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalTriggeringElement: null,
      showModal: false,
      isLoadingJobs: false,
      isLoadingPersonality: false,
      isSavingPersonality: false,
      hasSavedPersonality: false,
      personality: null,
      fileSize: '',
      jobs: [],
      processingJobs: new Set()
    };

    this.handleToggleModal = this.handleToggleModal.bind(this);
    this.handleSavePersonality = this.handleSavePersonality.bind(this);
    this.handleToggleJob = this.handleToggleJob.bind(this);
  }

  componentDidMount() {



    // Get the PDF file header information.
    this.getFileHeaders(this.props.animal.pdf)
      .then(response => {
        this.setState({
          fileSize: `${Math.ceil(response.headers['content-length'] / 1024)} KB`
        });
      });

    // Get the saved personality for the user.
    this.setState({
      isLoadingPersonality: true
    });

    this.getPersonality()
      .then(response => {
        this.setState({
          personality: response.data || null,
          isLoadingPersonality: false
        });
      });

    // Get the saved jobs for the user.
    this.setState({
      isLoadingJobs: true
    });

    this.getJobs()
      .then(response => {
        this.setState({
          jobs: response.data.data,
          isLoadingJobs: false
        });
      });
  }

  async getPersonality() {
    return this.props.authentication.callWithToken(async token => {
      return axios.get(config.endpoints.webcontactPersonality, {
        headers: {
          Authorization: 'Bearer ' + token,
          'Accept-Language': i18n.language
        },
      })
        .catch(error => {
          console.log(error);
        });
    });
  }

  async savePersonality(id) {
    return this.props.authentication.callWithToken(async token => {
      return axios.post(`${config.endpoints.webcontactPersonality}/${id}`, {}, {
        headers: {
          Authorization: 'Bearer ' + token,
          'Accept-Language': i18n.language,
        },
      });
    });
  }

  async getFileHeaders(url) {
    return axios.head(url)
      .catch(error => {
        console.log(error);
      });
  }

  async getJobs() {
    return this.props.authentication.callWithToken(async token => {
      return axios.get(config.endpoints.webcontactJobs, {
        headers: {
          Authorization: 'Bearer ' + token,
          'Accept-Language': i18n.language,
          groupSize: 999,
          page: 1
        },
      })
        .catch(error => {
          console.log(error);
        });
    });
  }

  async saveJob(slug) {
    return this.props.authentication.callWithToken(async token => {
      return axios.post(config.endpoints.webcontactJobs, { slug: slug }, {
        headers: {
          Authorization: 'Bearer ' + token,
          'Accept-Language': i18n.language,
        },
      });
    });
  }

  async deleteJob(slug) {
    return this.props.authentication.callWithToken(async token => {
      return axios.delete(config.endpoints.webcontactJobs, {
        headers: {
          Authorization: 'Bearer ' + token,
          'Accept-Language': i18n.language,
        },
        data: [slug],
      });
    });
  }

  handleToggleModal(e) {
    if (this.state.showModal) {
      this.state.modalTriggeringElement.focus();

      this.setState({
        modalTriggeringElement: null,
        showModal: false
      });
    }
    else {
      this.setState({
        modalTriggeringElement: e.currentTarget,
        showModal: true
      });
    }
  }

  handleSavePersonality(e) {
    this.setState({
      isSavingPersonality: true
    });

    const id = this.props.animal.id;

    this.savePersonality(id)
      .then(response => {
        this.setState({
          isSavingPersonality: false,
          hasSavedPersonality: true,
          personality: this.props.animal
        });
      });
  }

  handleToggleJob(e) {
    const processingJobs = this.state.processingJobs

    processingJobs.add(e.target.value)

    this.setState({
      processingJobs: processingJobs,
    })

    const isSavedJob = this.state.jobs.some(job => job.slug === e.target.value)

    if (isSavedJob) {
      this.deleteJob(e.target.value)
        .then(response => {
          this.getJobs()
            .then(response => {
              this.setState({
                jobs: response.data.data,
              });
            })
            .then(() => {
              processingJobs.delete(e.target.value)

              this.setState({
                processingJobs: processingJobs,
              });
            });
        });
    } else {
      this.saveJob(e.target.value)
        .then(response => {
          this.getJobs()
            .then(response => {
              this.setState({
                jobs: response.data.data,
              });
            })
            .then(() => {
              processingJobs.delete(e.target.value)

              this.setState({
                processingJobs: processingJobs,
              });
            });
        });
    }
  }

  render() {


    return (
      <AuthenticationContext.Consumer>
        {({ isAuthenticated, login }) => (
          <Fragment>
            <h1>{this.props.t('results.title')}</h1>
            <Modal
              show={this.state.showModal}
              title={this.props.t('results.components.saveModal.title')}
              html={'&nbsp;'}
              cancelButtonLabel={this.props.t('results.components.saveModal.button.cancel')}
              onCancel={this.handleToggleModal}
              onConfirm={(e) => {
                this.handleSavePersonality(e);
                this.handleToggleModal(e);
              }}
            // ariaLabelConfirm={this.props.confirmTitle}
            // ariaLabelCancel={this.props.cancelTitle}

            // disabled={this.state.isDeleting}
            // spinner={this.state.isDeleting}
            />
            <GelContentRow>
              <StackedCard
                link={false}
                // title={<h2 style={{ marginTop: 0 }}>{this.props.t('results.assignment') + ' ' + this.props.animal.title}</h2>}
                source={this.props.animal.image.url}
                alt={this.props.animal.image.alt}
                width={100}
                imageRight={true}
              >
                <div dangerouslySetInnerHTML={{ __html: this.props.animal.summary }} />
              </StackedCard>
            </GelContentRow>
            {isAuthenticated &&
              <div className='gel-xs-mb-20'>
                {this.state.hasSavedPersonality &&
                  <Notice type={'positive'}>
                    {this.props.t('results.components.saveNotice.text')}
                  </Notice>
                }
                <ButtonSecondary
                  title={this.props.t('results.components.saveButton.title')}
                  onClick={this.state.personality ? this.handleToggleModal : this.handleSavePersonality}
                  spinner={this.state.isSavingPersonality}
                  disabled={this.state.isSavingPersonality || this.state.isLoadingPersonality}
                >
                  {this.props.t('results.components.saveButton.text')}
                </ButtonSecondary>
              </div>
            }
            <Tabs
              items={[
                {
                  title: this.props.t('results.tabs.personality.title'),
                  link: this.props.baseRoute + '/' + this.props.t('results.tabs.personality.slug')
                },
                {
                  title: this.props.t('results.tabs.job.title'),
                  link: this.props.baseRoute + '/' + this.props.t('results.tabs.job.slug')
                },
                {
                  title: this.props.t('results.tabs.education.title'),
                  link: this.props.baseRoute + '/' + this.props.t('results.tabs.education.slug')
                }
              ]}
            />

            {/* Personality tab */}
            {this.props.params.tab === this.props.t('results.tabs.personality.slug') &&
              <Fragment>
                {/* <h2>{this.props.t('results.tabs.personality')}</h2>
                <h3 id="strengths" tabIndex={-1}>{this.props.t('results.strengths', { animal: this.props.animal.title })}</h3>
                <div dangerouslySetInnerHTML={{ __html: this.props.animal.strengths }} />
                <h3 id="children" tabIndex={-1}>{this.props.t('results.children')}</h3>
                <div dangerouslySetInnerHTML={{ __html: this.props.animal.children }} />
                <h3 id="young" tabIndex={-1}>{this.props.t('results.young')}</h3>
                <div dangerouslySetInnerHTML={{ __html: this.props.animal.young }} />
                <h3 id="friend" tabIndex={-1}>{this.props.t('results.friend')}</h3>
                <div dangerouslySetInnerHTML={{ __html: this.props.animal.friend }} />
                <h3 id="boss" tabIndex={-1}>{this.props.t('results.boss')}</h3>
                <div dangerouslySetInnerHTML={{ __html: this.props.animal.boss }} />
                <h3 id="tips" tabIndex={-1}>{this.props.t('results.tips')} {this.props.animal.plural}</h3>
                <div dangerouslySetInnerHTML={{ __html: this.props.animal.tips }} /> */}
                <div dangerouslySetInnerHTML={{ __html: this.props.animal.body }} />
              </Fragment>
            }

            {/* Job tab */}
            {this.props.params.tab === this.props.t('results.tabs.job.slug') &&
              <Fragment>
                <div dangerouslySetInnerHTML={{ __html: this.props.animal.jobSummary }} />
                <Notice type={'info-icon'}>
                  <div dangerouslySetInnerHTML={{ __html: this.props.animal.jobNotice }} />
                </Notice>
                <Form classes={['form--no-background', 'form--no-padding']}>
                  {this.props.animal.traits.map((trait, index) => {
                    if (!trait.title) {
                      return null;
                    }

                    return (
                      <Fragment key={index}>
                        <h3>{trait.title}</h3>
                        <Table
                          caption={this.props.t('results.table.caption')}
                          hideCaption={true}
                          isSelectable={true}
                          headers={[
                            <Fragment>
                              <div
                                className='visually-hidden'
                                aria-hidden='true'
                              >
                                <CheckboxElement
                                  label={''}
                                  onChange={() => { }}
                                  checked={false}
                                  value={''}
                                  disabled={true}
                                />
                              </div>
                              <span>{this.props.t('results.table.header.save')}</span>
                            </Fragment>,
                            this.props.t('results.table.header.title')
                          ]}
                          rows={trait.jobs.filter(job => job).map(job => {
                            let isSavedJob = this.state.jobs.some(webcontactJob => webcontactJob.slug === job.slug);
                            let isLoadingJob = this.state.processingJobs.has(job.slug);

                            return [
                              <CheckboxElement
                                label={
                                  isSavedJob
                                    ? this.props.t('results.table.checkbox.label.saved')
                                    : this.props.t('results.table.checkbox.label.unsaved')
                                }
                                onChange={this.handleToggleJob}
                                checked={isSavedJob}
                                value={job.slug}
                                isLoading={isLoadingJob}
                                disabled={!isAuthenticated || this.state.isLoadingJobs}
                              />,
                              <a href={route('jobInformationJob', { job: job.slug })}>
                                {job.title}
                              </a>
                            ].filter(header => header);
                          })}
                        />
                      </Fragment>
                    );
                  })}
                </Form>
                {/* <h3>{this.props.t('results.industries', { animal: this.props.animal.plural })}</h3> */}
                <h3>{this.props.t(`results.industry.${this.props.animal.code}`)}</h3>
                <ul className="style style--list-large style--columns-2">
                  {this.props.animal.industries.map((industry, index) => {
                    if (!industry) {
                      return
                    }

                    return (
                      <li key={index}>
                        <a href={route('jobInformationIndustry', { industry: industry.slug })}>
                          {industry.title}
                        </a>
                      </li>
                    );
                  })}
                </ul>
                <hr />
              </Fragment>
            }

            {/* Education tab */}
            {this.props.params.tab === this.props.t('results.tabs.education.slug') &&
              <Fragment>
                {/* <h2>{this.props.t('results.tabs.education.title')}</h2> */}
                <div dangerouslySetInnerHTML={{ __html: this.props.animal.education }} />
              </Fragment>
            }

            {!isAuthenticated &&
              <Fragment>
                <h3>{this.props.t('results.save')}</h3>
                <p>
                  <Trans i18nKey={'local:results.saveToProfile'}>
                    <Button asLink={true} onClick={login} role="button" />
                  </Trans>
                </p>
                <p>{this.props.t('results.downloadFile')}</p>
                <DocumentDownload
                  type="pdf"
                  size={this.state.fileSize}
                  url={this.props.animal.pdf}
                  target='_blank'
                  title={this.props.animal.name}
                />
                <hr />
              </Fragment>
            }
            <GelContentRow>
              <CallToActionCard
                title={this.props.t('results.cta.title')}
                background={CardBackground}
                link={{
                  to: route('animals'),
                  value: this.props.t('results.cta.linktext')
                }}
              >
                {this.props.t('results.cta.body')}
              </CallToActionCard>
            </GelContentRow>
            <ButtonCta
              url={route('step1')}
              onClick={this.props.resetAnswers}
            >
              {this.props.t('results.retake')}
            </ButtonCta>
            {isAuthenticated &&
              <Fragment>
                <h3>{this.props.t('results.download')}</h3>
                <DocumentDownload
                  type='pdf'
                  size={this.state.fileSize}
                  url={this.props.animal.pdf}
                  target='_blank'
                  title={this.props.animal.name}
                />
              </Fragment>
            }
            <hr />
            <h3>{this.props.t('results.explore')}</h3>
            <GelContentRow>
              {/* {this.props.animal.ads.map((ad, index) => {
                return (
                  <IconCard
                    width={100}
                    title={ad.displayName}
                    link={{ to: ad.adUrl }}
                    source={ad.imageUrl}
                    alt={ad.altText}
                  />
                );
              }, this)} */}
              {this.props.params.tab === this.props.t('results.tabs.job.slug') &&
                <IconCard
                  width={100}
                  title={this.props.t('results.components.jobsCard.title')}
                  link={{ to: route('jobInformation') }}
                  source={CardJobInformation}
                  alt={this.props.t('results.components.jobsCard.title')}
                >
                  {this.props.t('results.components.jobsCard.body')}
                </IconCard>
              }
              {this.props.params.tab === this.props.t('results.tabs.education.slug') &&
                <IconCard
                  width={100}
                  title={this.props.t('results.components.subjectsCard.title')}
                  link={{ to: route('jobInformationSubjects') }}
                  source={CardSubjectsJobs}
                  alt={this.props.t('results.components.subjectsCard.title')}
                >
                  {this.props.t('results.components.subjectsCard.body')}
                </IconCard>
              }
              <IconCard
                width={100}
                title={this.props.t('results.components.quizCard.title')}
                link={{ to: route('careerMatchQuiz') }}
                source={CardCareerMatchQuiz}
                alt={this.props.t('results.components.quizCard.title')}
              >
                {this.props.t('results.components.quizCard.body')}
              </IconCard>
            </GelContentRow>
            {/* <GelContentRow>
          <GelContentColumn md={3}>
            <SideNavigation
              title={this.props.t('results.contents')}
              items={[
                {
                  text: (i18n.language === 'en') ? this.props.animal.title + ' ' + this.props.t('results.strengths') : this.props.t('results.strengths') + ' ' + this.props.animal.title,
                  url: '#strengths'
                },
                {
                  text: this.props.t('results.job'),
                  url: '#inajob'
                },
                {
                  text: this.props.t('results.sectors') + ' ' + this.props.animal.title,
                  url: '#sectors'
                },
                {
                  text: this.props.t('results.children'),
                  url: '#children'
                },
                {
                  text: this.props.t('results.young'),
                  url: '#young'
                },
                {
                  text: this.props.t('results.friend'),
                  url: '#friend'
                },
                {
                  text: this.props.t('results.boss'),
                  url: '#boss'
                },
                {
                  text: this.props.t('results.tips') + ' ' + this.props.animal.plural,
                  url: '#tips'
                },
                {
                  text: this.props.t('results.view'),
                  url: '#view'
                },
              ]}
            />
          </GelContentColumn>
          <GelContentColumn md={9}>
            {i18n.language === 'en' &&
              <h3 id="strengths" tabIndex={-1}>{this.props.animal.title} {this.props.t('results.strengths')}</h3>
            }
            {i18n.language === 'cy' &&
              <h3 id="strengths" tabIndex={-1}> {this.props.t('results.strengths')} {this.props.animal.title}</h3>
            }
            <div dangerouslySetInnerHTML={{ __html: this.props.animal.strengths }} />
            <br /><br />
            <h3 id="inajob" tabIndex={-1}>{this.props.t('results.job')}</h3>
            {this.props.animal.jobsList.map((job, index) => {
              return (
                <div key={index}>
                  <div className="style--highlighted">
                    <GelContentRow>
                      <div className="gel-content-col-md-6">
                        {i18n.language === 'en' &&
                          <p>{this.props.animal.plural} {this.props.t('results.proposition')}:</p>
                        }
                        {i18n.language === 'cy' &&
                          <p>Mae {this.props.animal.plural} {this.props.t('results.proposition')}:</p>
                        }
                        <ul className="style--list-square style--list-no-bg">
                          {job.map((attribute, index) => {
                            return (
                              <li key={index}>{attribute}</li>
                            );
                          })}
                        </ul>
                      </div>
                      <div className="gel-content-col-md-6">
                        <p>{this.props.t('results.jobslist')}:</p>
                        <ul>
                          {this.props.animal.jobs[index] && this.props.animal.jobs[index].map((career, index) => {
                            return (
                              <li key={index}>
                                <a
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  href={career.jobUrl}
                                >
                                  {career.displayName}
                                </a>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </GelContentRow>
                  </div>
                  <br />
                </div>
              );
            })}
            <h3 id="sectors" tabIndex={-1}>{this.props.t('results.sectors')} {this.props.animal.title}</h3>
            <ul>
              {this.props.animal.sectors.map((sector, index) => {
                return (
                  <li key={index}>{sector.displayName}</li>
                );
              })}
            </ul>
            <br /><br />
            <h3 id="children" tabIndex={-1}>{this.props.t('results.children')}</h3>
            <div dangerouslySetInnerHTML={{ __html: this.props.animal.children }} />
            <br /><br />
            <h3 id="young" tabIndex={-1}>{this.props.t('results.young')}</h3>
            <div dangerouslySetInnerHTML={{ __html: this.props.animal.young }} />
            <br /><br />
            <h3 id="friend" tabIndex={-1}>{this.props.t('results.friend')}</h3>
            <div dangerouslySetInnerHTML={{ __html: this.props.animal.friend }} />
            <br /><br />
            <h3 id="boss" tabIndex={-1}>{this.props.t('results.boss')}</h3>
            <div dangerouslySetInnerHTML={{ __html: this.props.animal.boss }} />
            <br /><br />
            <h3 id="tips" tabIndex={-1}>{this.props.t('results.tips')} {this.props.animal.plural}</h3>
            <div dangerouslySetInnerHTML={{ __html: this.props.animal.tips }} />
            <br /><br />
            <div id="view">
              <GelContentRow>
                <CallToActionCard
                  title={this.props.t('results.cta.title')}
                  link={{
                    to: route('animals'),
                    value: this.props.t('results.cta.linktext')
                  }}
                >
                  {this.props.t('results.cta.body')}
                </CallToActionCard>
              </GelContentRow>
            </div>
            <ButtonCta
              url={route('step1')}
              onClick={this.props.resetAnswers}
            >
              {this.props.t('results.retake')}
            </ButtonCta>
            <hr className="thin" />
            <h3>{this.props.t('results.also')}</h3>
            <GelContentRow>
              {this.props.animal.ads.map((ad, index) => {
                return (
                  <RegularCard
                    key={index}
                    width={33}
                    link={{
                      to: ad.adUrl,
                      target: '_blank'
                    }}
                    alt={ad.altText}
                    source={ad.imageUrl}
                    title={ad.displayName}
                  />
                );
              }, this)}
            </GelContentRow>
            <hr className="thick" />
            <h3>{this.props.t('results.documents')}</h3>
            <p>{this.props.t('results.nopdf')}</p>
            <DocumentDownload
              type="pdf"
              size={this.props.animal.pdfSize}
              url={this.props.animal.pdf}
              target='_blank'
              title={this.props.t('results.download') + this.props.animal.title + this.props.t('results.downloadsuffix')}
            />
          </GelContentColumn>
        </GelContentRow> */}
          </Fragment>
        )}
      </AuthenticationContext.Consumer>
    );
  }
}

export default withAuthentication(withRouter(withTranslation('local')(Animal)));
